import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostBinding
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssIconComponent } from '../icon/icon.component';

@Component({
  selector: 'umss-filter-chip',
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: './filter-chip.component.html',
  styleUrls: ['./filter-chip.component.scss']
})
export class UmssFilterChipComponent<T> {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** Content props */
  @Input() text: string = 'Filter'; // Filter chip text
  @Input() value?: T; // Value associated with this filter

  /** Variant props */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular'; // Size variant
  @Input() variant: 'Default' | 'Outlined' = 'Default'; // Visual variant

  /** State props */
  @Input() removable: boolean = true; // Whether chip can be removed

  /** Event outputs */
  @Output() chipClick = new EventEmitter<T>();
  @Output() chipRemove = new EventEmitter<T>();

  /** Event handlers */
  onChipClick(event: MouseEvent): void {
    event.stopPropagation();
    this.chipClick.emit(this.value);
  }

  onRemoveClick(event: MouseEvent): void {
    event.stopPropagation();
    this.chipRemove.emit(this.value);
  }
}
